// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3p2S-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/image/ImageMenu.css
// module id = 823
// module chunks = 0